import algoliasearch from "algoliasearch/lite";

const ALGOLIA_API_KEY = "bf637a355161eab5c4f2b17e397a752a";
const ALGOLIA_APP_ID = "4HMMQB7YDD";
export const ALGOLIA_HITS_PER_PAGE = 10;

const algoliaClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY);

export const searchClient = {
	...algoliaClient,
	search(requests) {
		//https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/react/#detecting-empty-search-requests
		if (requests.every(({ params }) => params?.query?.length === 0)) {
			return Promise.resolve({
				results: requests.map(() => ({
					hits: [],
					nbHits: 0,
					nbPages: 0,
					page: 0,
					processingTimeMS: 0,
					hitsPerPage: 0,
					exhaustiveNbHits: false,
					query: "",
					params: "",
				})),
			});
		}

		return algoliaClient.search(requests);
	},
};
